import styled from '@emotion/styled';

import { CircularProgress } from '@mui/material';
import { MainButton, MainButtonVariant } from '../../styledComponent/Buttons.style';
import { TabletWidth } from '../../../global.style';

const DivIButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;

  @media (max-width: ${TabletWidth}px) {
    width: 100%;
    margin: 0;
  }
`;

interface MainFunnelButtonV2Props {
  text: string;
  onClick: () => void;
  disabled: boolean;
  id: string;
  isLoading?: boolean;
  variant?: MainButtonVariant;
}

export const MainFunnelButtonV2 = ({
  text,
  onClick,
  disabled,
  id,
  isLoading = false,
  variant = MainButtonVariant.Gradient,
}: MainFunnelButtonV2Props) => {
  return (
    <DivIButton>
      <MainButton id={id} disabled={disabled || isLoading} onClick={onClick} variant={variant}>
        {isLoading ? <CircularProgress color={'inherit'} size={'2rem'} /> : text}
      </MainButton>
    </DivIButton>
  );
};
